import { useTranslation } from 'react-i18next'

import { getBirdviewCardBodyContent } from '../BirdviewCard.utils'

import * as styles from './BirdviewCardBody.module.css'

function BirdviewCardBody({
  children,
  emptyKey = 'DashboardBirdview.EmptyStateKey',
  state,
  onRetry,
}) {
  const { t } = useTranslation()

  return (
    <div className={styles.body}>
      {getBirdviewCardBodyContent({ children, emptyKey, state, t, onRetry })}
    </div>
  )
}

export default BirdviewCardBody
